<template>
     <button type="button" class="btn btn-success" @click="$emit('close')">Cerrar</button><p/>
    <div class="card">
    <iframe :src="pdfSrc" width="100%" height="800px"></iframe>
    </div>
</template>
<script>
import { ref } from 'vue'
import filiation from "@/filiation/composables/useFiliation";
import useAddTransferDeparture from "@/addTransfersDepartures/composables/useAddTransferDeparture";
export default {
  name: 'documentViewer',
  props: {
    documentType: String,
    documentId: String
  },
    setup(props) {
        const pdfSrc = ref('');
        const {
          kardex,
          resolution,
        } = filiation();
        const {
            printAddTransferDeparture
        } = useAddTransferDeparture();
        const getDocument = async(type, id) =>{
            try {
                console.log("type", type);
             let response = ''
                if (type==='resolucion') {
                 const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/filiacion/view_file/"+id)
                    // response = await resolution(id)
                } else if(type==='kardex'){
                    response = await kardex(id)
                }else if(type!=='resolucion' || type!=='kardex' ){
                    response = await printAddTransferDeparture({ id: id, tipo: type })
                }
                    const pdfUrl = URL.createObjectURL(response);
                    pdfSrc.value = pdfUrl;
            } catch (error) {
                console.error('Error al cargar el PDF:', error);
            }
        }
        console.log(props.documentId);
        if(props.documentType && props.documentId){
            getDocument(props.documentType, props.documentId)
        }
        
        const saludo = ref("hola");
        return{
            saludo,
            pdfSrc
        }
    },
}
</script>